import { render, staticRenderFns } from "./AxManageUsersJoin.vue?vue&type=template&id=558da494&"
import script from "./AxManageUsersJoin.vue?vue&type=script&lang=ts&"
export * from "./AxManageUsersJoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports